import { combineReducers } from "redux";
import usersReducer from "./users/usersReducer";
import clientsReducer from "./clients/clientsReducer";
import projectsReducer from "./projects/projectsReducer";
import tasksReducer from "./projects/tasksReducer";
import dailyTasksReducer from "./dailyTask/taskReducer";
import commonReducer from "./commonReducer";
import timesheetReducer from "./timesheet/timesheetReducer";
import approvalsReducer from "./timesheet/approvalsReducer";
import calendarReducer from "./dashboard/calendarReducer";
import subordinatesReducer from "./dashboard/subordinatesReducer";
import reportsReducer from "./reports/reportsReducer";
import platformReducer from "./platforms/platformReducer";
import departmentReducer from "./departments/departmentReducer";
import bandReducer from "./bands/bandReducer";
import budgetRequestsReducer from "./projects/budgetRequestsReducer";
import holidaysReducer from "./holidays/holidaysReducer";
import activitiesReducer from "./activities/activitiesReducer";
import costCenterReducer from "./cost_centers/costCenterReducer";

const rootReducer = combineReducers({
  users: usersReducer,
  clients: clientsReducer,
  projects: projectsReducer,
  tasks: tasksReducer,
  dailyTasks: dailyTasksReducer,
  common: commonReducer,
  timesheets: timesheetReducer,
  approvals: approvalsReducer,
  calendar: calendarReducer,
  subordinates: subordinatesReducer,
  reports: reportsReducer,
  platforms: platformReducer,
  departments: departmentReducer,
  bands: bandReducer,
  budgetRequests: budgetRequestsReducer,
  holidays: holidaysReducer,
  activities: activitiesReducer,
  costCenters: costCenterReducer,
});

export default rootReducer;
